package navigation.home.itineraryoverview

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.itinerary.ui.itinerary_overview.ItineraryOverviewEvent
import com.essntl.features.itinerary.ui.itinerary_overview.ItineraryOverviewState
import com.essntl.features.itinerary.ui.itinerary_overview.ItineraryOverviewViewModel
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase

class ItineraryOverviewScreenModel(
    itineraryRepository: ItineraryRepository,
    getCurrentUserUseCase: GetCurrentUserUseCase,
    loadingManager: LoadingManager,
) : StateScreenModel<ItineraryOverviewState>(ItineraryOverviewState()) {
    private val itineraryOverviewViewModel =
        ItineraryOverviewViewModel(
            itineraryRepository = itineraryRepository,
            getCurrentUserUseCase = getCurrentUserUseCase,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: ItineraryOverviewEvent) = itineraryOverviewViewModel.onEvent(event)
}
